import { classNames } from "@/lib/utils";

export const Header = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return <div className={classNames("font-semibold text-10-10 uppercase text-text-base-4", className)}>{children}</div>;
};
